import React from 'react';
import { GameLayout } from '@/components/layout/GameLayout';
import { MemoryGame } from '@/components/games/memory/MemoryGame';

export default function MemoryGamePage() {
  return (
    <GameLayout
      title="Memory Cards"
      description="Mejora tu memoria financiera con este juego de cartas"
    >
      <MemoryGame />
    </GameLayout>
  );
}
